<template>
    <v-dialog v-model="announcementsShow" persistent max-width="600">
      <v-card>
        <v-card-text class="headline">
          <v-card
            v-for="(announcement, index) in announcements"
            :key="index"
            class="mb-3">
            <v-card-title class="justify-center">{{announcement.title}}</v-card-title>
            <v-card-text class="headline">
              <p class="body-1 mb-0" v-html="announcement.text"></p>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="justify-center">
            <v-btn
              class="mb-3"
              color="secondary"
              width="100"
              @click="closeDialog"
            >Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  components: {
  },
  props: {
    announcements: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      announcementsShow: true,
    };
  },
  methods: {
    closeDialog() {
      this.$emit('change', {
        announcementsShow: false,
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/MPayAnnouncements.vue